import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelfregisterApiService } from '@icullen/api/public';
import { AnalyticsService } from '@icullen/api/shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'icullen-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss'],
})
export class ActivateAccountComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  showErrorMessage = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private selfRegisterUserService: SelfregisterApiService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    const activationCode =
      this.route.snapshot.queryParamMap.get('activationCode');
    this.sub = this.selfRegisterUserService
      .activateAccount(activationCode)
      .subscribe((response) => {
        //console.log(response);
        if (response.succeeded) {
          this.showErrorMessage = false;
          this.analyticsService.pushSelfRegisterEvent_StepAccountActivationSuccess();
          const destinationUrl =
            this.route.snapshot.queryParamMap.get('destination');
          if (destinationUrl) {
            window.location.href = destinationUrl;
          } else {
            this.router.navigate(['/']);
          }
        } else {
          this.showErrorMessage = true;
          this.analyticsService.pushSelfRegisterAccountActivationFailureEvent(
            this.router.url
          );
        }
      });
  }

  ngOnDestroy() {
    this.showErrorMessage = false;
    this.sub.unsubscribe();
  }
}
